// extracted by mini-css-extract-plugin
module.exports = {"svgWrapped":"SvgWithTooltip_svgWrapped__mKn8u","svgTooltip":"SvgWithTooltip_svgTooltip__N4rNO"};